import LanguageSelector from '../../../Components/Common/LanguageSelector'
import { cap } from '../../../State'
import { useQuoteI18n } from '../quoteI18n'

/**
 * Lingua e tema, in cima alla pagina preventivo.
 *
 * Stessi due controlli della topbar dell'app e stesse classi (`nora-lang`,
 * `nora-theme-switch`, in `nora-design-system.css` caricato da `index.html`), così il
 * viaggiatore vede la stessa identità visiva.
 *
 * Il tema scrive su `cap.darkMode`, che `App.jsx` propaga su `<html data-theme>`: i token
 * CSS della pagina si rimappano da sé. La lingua invece **non** tocca `cap.language` —
 * quella è la preferenza dell'operatore, e questa pagina la apre il viaggiatore
 * (v. `i18n.jsx`).
 */
export function QuoteToolbar() {
  const { language, changeLanguage, t } = useQuoteI18n()
  const [darkMode, setDarkMode] = cap.darkMode.useState()

  return (
    <div className="gq-toolbar">
      <LanguageSelector value={language.toUpperCase()} onChange={changeLanguage} />
      <button
        type="button"
        className={`nora-theme-switch${darkMode ? ' is-dark' : ''}`}
        onClick={() => setDarkMode(!darkMode)}
        aria-label={darkMode ? t.toolbar.toLight : t.toolbar.toDark}
        aria-pressed={darkMode}
      >
        <span className="nora-theme-switch__thumb">
          <i className={`pi ${darkMode ? 'pi-moon' : 'pi-sun'}`} aria-hidden="true" />
        </span>
      </button>
    </div>
  )
}
